import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  InputLabel,
  FormControl,
  Select,
  Box,
} from '@mui/material';
import { useDispatch } from 'react-redux';
// components
import Scrollbar from '../../../components/scrollbar';
import api from '../../../api';

// mock

import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { row_per_page_data } from 'src/utils/commonUtils';
import UserListHead from '../user/UserListHead';
import { useParams } from 'react-router-dom';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'User Name', alignRight: false },
  { id: 'username', label: 'Mobile Number', alignRight: false },
  { id: '_id', label: 'Bid ID', alignRight: false },
  { id: 'game_name', label: 'Game Name', alignRight: false },
  { id: 'gmae_type', label: 'Game Type', alignRight: false },
  { id: 'session', label: 'Session', alignRight: false },
  { id: 'open_panna', label: 'Open Pana', alignRight: false },
  { id: 'open_digit', label: 'Open Digit', alignRight: false },
  { id: 'close_pana', label: 'Close Pana', alignRight: false },
  { id: 'close_digit', label: 'Close Digit', alignRight: false },
  { id: 'points', label: 'Points', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function BidPage({ falseLoading }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(row_per_page_data[1]);

  const [bidsData, setBidsData] = useState([]);

  const [selectedGame, setSelectedGame] = useState('');
  let userId = useParams();



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = bidsData?.results?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    if (newPage + 1 > bidsData.currentPage) {
      getAllBids(newPage + 1);
    }

    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const getAllBids = async (pg) => {
    let endpoint = `/bids/user-bid-history/${userId?.id}`;
    const response = await api.get(endpoint);

    setBidsData({
      totalBids: response.data.totalBids,
      currentPage: response.data.currentPage,
      totalPages: response.data.totalPages,
      results: pg === 1 ? response.data.results : [...bidsData.results, ...response.data.results],
    });
  };

  useEffect(() => {
    getAllBids(1);
  }, []);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - bidsData?.totalBids) : 0;

  const filteredFinalData = applySortFilter(
    bidsData?.results ? bidsData?.results : [],
    getComparator(order, orderBy),
    filterName
  );

  const isNotFound = !filteredFinalData.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={bidsData.totalBids}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredFinalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((row) => {
                    const {
                      _id,
                      user,
                      game_id,
                      game_type_id,
                      open_digit,
                      close_digit,
                      points,
                      session,
                      close_panna,
                      open_panna,
                    } = row;
                    const selectedUser = selected.indexOf(game_id?.game_name) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          {/* <Checkbox
                            checked={selectedUser}
                            onChange={(event) => handleClick(event, game_id?.game_name)}
                          /> */}
                        </TableCell>

                        <TableCell align="left">{user?.name}</TableCell>

                        <TableCell align="left">{user?.email}</TableCell>

                        <TableCell align="left">{_id.slice(0, 5)}...</TableCell>

                        <TableCell align="left">{game_id?.game_name}</TableCell>

                        <TableCell align="left">{game_type_id?.game_type_name}</TableCell>

                        <TableCell align="left">{session}</TableCell>
                        <TableCell align="left">{open_panna || '-'}</TableCell>

                        <TableCell align="left">{open_digit || '-'}</TableCell>

                        <TableCell align="left">{close_panna || '-'}</TableCell>

                        <TableCell align="left">{close_digit || '-'}</TableCell>

                        <TableCell align="left">{points}</TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={row_per_page_data}
            component="div"
            count={filteredFinalData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </>
  );
}
